var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import View from '../View';
var Page = styled(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 100vh;\n  width: 100vw;\n"], ["\n  min-height: 100vh;\n  width: 100vw;\n"])));
export default Page;
var templateObject_1;
//# sourceMappingURL=Page.js.map